import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreHorizontal, Eye, Edit, Trash2 } from 'lucide-react'
import PaginationComponent from '@/components/common/PaginationComponent'
import { formatTableText } from '@/lib/tableUtils'

const PortsTable = ({ 
  ports, 
  onViewPort, 
  onEditPort, 
  onDeletePort,
  currentPage,
  totalPages,
  totalPorts,
  pageSize,
  onPageChange
}) => {
  const getStatusVariant = (status) => {
    switch (status) {
      case 'Active':
        return 'active'
      case 'Inactive':
        return 'delayed'
      case 'Maintenance':
        return 'pending'
      default:
        return 'default'
    }
  }

  return (
    <div className="rounded-md border overflow-hidden w-full">
      <div className="max-h-[calc(100vh-250px)] overflow-auto w-full">
        <Table>
          <TableHeader className=" sticky top-0 z-10">
            <TableRow>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Port Name</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[150px]">Port Code</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[150px]">Type</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[100px]">Status</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Created At</TableHead>
              <TableHead className="h-10 px-4 py-1 text-right min-w-[80px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {ports.map((port) => (
              <TableRow key={port.id} className="hover:bg-transparent border-border">
                <TableCell className="h-10 px-4 py-1">{formatTableText(port.name) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1 uppercase">{formatTableText(port.code) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(port.porttype) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">
                  <Badge
                    variant={getStatusVariant(port.status)}
                    className="inline-block text-center w-[80px]"
                  >
                    {port.status || 'N/A'}
                  </Badge>
                </TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(port.createdAt) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1 text-right">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      <DropdownMenuItem onClick={() => onViewPort(port.id)}>
                        <Eye className="mr-2 h-4 w-4" />
                        View in Map
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => onEditPort(port.id)}>
                        <Edit className="mr-2 h-4 w-4" />
                        Edit Port
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => onDeletePort(port.id)} className="text-red-500">
                        <Trash2 className="mr-2 h-4 w-4" />
                        Delete Port
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      
      <PaginationComponent
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalPorts}
        pageSize={pageSize}
        onPageChange={onPageChange}
        className="border-t"
      />
    </div>
  )
}

export default PortsTable